
import {computed, defineComponent} from 'vue';
import {useStore} from "vuex";

export default defineComponent({
  name: 'Sidebar',
  components: {},
  setup() {
    const store = useStore()

    return {
      posts: computed(() => store.getters.topPosts),
    }
  },
});
